import React, { useMemo } from 'react';
import _get from 'lodash/get';

import { If } from 'utils';
import { UiKit } from 'components';
import { Loader } from './components';
import { FeatureContainer } from '../../components';
import * as ReturnProcessingFee from './ReturnProcessingFee';
import * as UnitRestockingFee from './UnitRestockingFee';
import * as PaymentProcessingFee from './PaymentProcessingFee';
import { useFTUWizard } from '../../context';

export default function Form() {
  const { onGotoNext } = useFTUWizard();
  const returnProcessingFee = ReturnProcessingFee.useReturnProcessingFee();
  const unitRestockingFee = UnitRestockingFee.useUnitRestockingFee();
  const paymentProcessingFee = PaymentProcessingFee.usePaymentProcessingFee();

  const configs = useMemo(() => {
    return [
      returnProcessingFee,
      unitRestockingFee,
      paymentProcessingFee
    ].filter(data => !!_get(data, 'isConfigurable', true));
  }, [returnProcessingFee, unitRestockingFee, paymentProcessingFee]);

  const isLoading = configs.some(config => config.isLoading);
  const isProcessing = configs.some(config => config.isProcessing);

  const onSave = () => {
    const fees = configs.filter(config => config.isDirty);

    if (!fees.length) return onGotoNext();

    const isValid = fees
      .map(fee => fee.onValidate(fee.data))
      .every(valid => valid);

    if (!isValid) return;

    const onSaveFees = fees.reduce((acc, fee) => {
      if (fee.isDirty) acc.push(fee.onSave());
      return acc;
    }, []);

    Promise.all(onSaveFees)
      .then(() => onGotoNext())
      .catch(err => onGotoNext(err));
  };

  return (
    <>
      <UiKit.Flex direction="column" gap="120">
        <FeatureContainer
          title="Do you want to enable additional fees?"
          subtitle="Add additional fees to offset costs or reduce return rates."
        >
          <Loader isLoading={isLoading}>
            <UiKit.Flex direction="column" gap={8}>
              <ReturnProcessingFee.Form isDisabled={isProcessing} />
              <UnitRestockingFee.Form isDisabled={isProcessing} />
              <If test={paymentProcessingFee.isConfigurable}>
                <PaymentProcessingFee.Form isDisabled={isProcessing} />
              </If>
            </UiKit.Flex>
          </Loader>
        </FeatureContainer>
      </UiKit.Flex>
      <If test={!isLoading}>
        <UiKit.Sheet.ActionsPortal>
          <UiKit.Button size="lg" onClick={onSave} processing={isProcessing}>
            Continue
          </UiKit.Button>
        </UiKit.Sheet.ActionsPortal>
      </If>
    </>
  );
}
